import { render, staticRenderFns } from "./OctSvg.vue?vue&type=template&id=9d420bfc&scoped=true&"
import script from "./OctSvg.vue?vue&type=script&lang=js&"
export * from "./OctSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d420bfc",
  null
  
)

export default component.exports